import countries from "../../../../countries.json";
import { transformUserAddress } from "../../../../data-transform";
import { countryOptions } from "../../../../enabled-countries";

const constructCountryOptions = () => {
    const countryNameOptions = [{ id: '', label: 'Select Country' }];
    countryOptions.map(({ subOptions }) => {
        subOptions.map(({ id }) => countryNameOptions.push({ id: id, label: id }));
    });

    // Sort the options alphabetically by label, keeping 'Select Country' at the top
    return countryNameOptions.sort((a, b) => {
        if (a.id === '') return -1; // Keep 'Select Country' at the top
        if (b.id === '') return 1;
        return a.label.localeCompare(b.label);
    });
}



export default function legalEntityTableColumnsSpecification(config) {
    if (!config.data) return null;
    const { legalEntityList = [] } = config.data;

    let result = {};
    let tableData = [];

    legalEntityList.forEach((entity, index) => {
        let row = [];
        const rowId = entity.legalEntityId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let displayInCell = true;
            // const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let columnValueData = null;
            let customEventHandler = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "legalEntityId") {
                    columnValue = entity.legalEntityId || "";
                }
                else if (columnId === 'legalEntityName') {
                    if(entity.legalEntityId === "")
                    {
                        columnDataType = "input";
                    }
                    columnValue = entity.legalEntityName || "";
                }                
            }
            if (columnDataType === "input") {
                // if (columnId === 'legalEntityId') {
                //     columnValueData = { ...column.data };
                //     columnValue = entity.legalEntityId || "";
                //     columnValueData.defaultValue = columnValue;
                // }
                
                if (columnId === 'legalEntityName') {
                    columnValueData = { ...column.data };
                    columnValue = entity.legalEntityName || "";
                    columnValueData.defaultValue = columnValue;
                }
                if (columnId === 'salesContractId') {
                    columnValueData = { ...column.data };
                    columnValue = entity.salesContractId || "";
                    columnValueData.defaultValue = columnValue;
                }
                customEventHandler = config.bodyButtonsHandler.inputChangeHandler ? event => config.bodyButtonsHandler.inputChangeHandler(event, columnId, index) : null;
            }
            else if (columnDataType === "editIconWithText") {
                if (columnId === 'billingAddress') {
                    const actionType = entity.billingAddress ? "edit" : "add";
                    const billingAddressData = entity.billingAddress;
                    const editButton = {
                        type: "icon",
                        endIcon: "edit",
                        iconStyle: { width: "20px", height: "20px" },
                        labelId: actionType,
                        isVisible: true,
                        clickHandler: config.bodyButtonsHandler.editAddressHandler ? (event) => config.bodyButtonsHandler.editAddressHandler(actionType, entity.legalEntityId, index) : null
                    };
                    
                    const deleteButton = {
                        type: "icon",
                        endIcon: "delete",
                        iconStyle: { width: "20px", height: "20px" },
                        labelId: "delete",
                        isVisible: entity.legalEntityId ? false : true,
                        clickHandler: config.bodyButtonsHandler.handleDeleteLegalEntityRowAction ? (event) => config.bodyButtonsHandler.handleDeleteLegalEntityRowAction(event, columnId, index) : null
                    }

                    columnValue = {
                        value: transformUserAddress(billingAddressData).join(", "),
                        buttons: [editButton, deleteButton]
                    }

                    // columnValue = `${entity.addressLine1}, ${entity.addressLine2}, ${entity.city}, ${entity.state}, ${entity.zipCode}, ${entity.addressCountry},`;
                }
                // customEventHandler = config.bodyButtonsHandler.editAddressHandler ? event => config.bodyButtonsHandler.editAddressHandler(event, columnId, index) : null;

            }
            else if (columnDataType === "select") {
                let options = [];

                if (columnId === 'legalCountry') {
                    if (entity.legalEntityId) {
                        columnDataType = "string";
                        columnValue = entity.legalCountry;
                    } else {
                        options = constructCountryOptions(countries);
                        columnValue = entity.legalCountry;
                        columnValueData = { ...column.data };
                        columnValueData.defaultValue = columnValue;
                        columnValueData.options = options;
                    }
                }
                customEventHandler = config.bodyButtonsHandler.inputChangeHandler ? event => config.bodyButtonsHandler.inputChangeHandler(event, columnId, index) : null;
            }
            else if (column.data.displayInBodyAs == "delete_Icon" && column.id == "delete") {
                columnValue = {
                    type: "icon",
                    endIcon: "delete",
                    iconStyle: { width: "20px", height: "20px" },
                    labelId: "delete",
                    clickHandler: config.bodyButtonsHandler.handleDeleteLegalEntityRowAction ? (event) => config.bodyButtonsHandler.handleDeleteLegalEntityRowAction(event, columnId, index) : null
                };
                if (entity.legalEntityId) {
                    displayInCell = false;
                }
                // customEventHandler = config.bodyButtonsHandler.handleDeleteLegalEntityRowAction ? event => config.bodyButtonsHandler.handleDeleteLegalEntityRowAction(event, columnId, index) : null;
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    displayInCell: displayInCell,
                    // highlightColumn: highlightColumn,
                    // linkDestination: linkDestination,
                    value: columnValueData || columnValue,
                    // showInMobileViewAs: column.showInMobileViewAs,
                    disabledCell: isDisabled,
                    clickHandler: (columnDataType !== "string" && customEventHandler) ? customEventHandler : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}